<div class="wrapper">
    <span class="loader"><span class="loader-inner"></span></span>
    <div style="text-align: center; position: absolute; top: 50%;">Loading...</div>
</div>